module.exports = __webpack_public_path__ + "static/use-case-8-content-2-c5e5fb248ea7dde2f7c0dd6f8b8ba3c5.png";